module.exports = __webpack_public_path__ + "img/ring_g_c_1_null.a1df1fc4.png";